import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Button, Form } from 'semantic-ui-react';

import { getValue } from '_utils';
import { licensePoolPropType, getLicensePoolAddSublicenseNameSelectionOptions } from '_utils/licensePools';

import BaseSelectField from '_forms/baseSelect';

const AddLicensePoolSublicenseForm = ({ licensePool, onCancel, onSubmit }) => {

  const [addon, setAddon] = useState(undefined);

  const isDirty = addon !== undefined;
  const onSubmitForm = () => isDirty && onSubmit(addon);
  const onChange = (e, data) => setAddon(getValue(data));

  return (
    <Form size='tiny' onSubmit={ onSubmitForm } >
      <Form.Group>
        <BaseSelectField
          width={ 16 }
          name='addon'
          value={ addon }
          onChange={ onChange }
          options={ getLicensePoolAddSublicenseNameSelectionOptions(licensePool) }
          labelTxt='Add On'
        />
      </Form.Group>
      <Button.Group>
        <Button onClick={ onCancel }>Cancel</Button>
        <Button.Or />
        <Button positive={ isDirty } disabled={ !isDirty } type="submit">Save</Button>
      </Button.Group>
    </Form>
  )
};

AddLicensePoolSublicenseForm.propTypes = {
  licensePool: licensePoolPropType.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default AddLicensePoolSublicenseForm;



// WEBPACK FOOTER //
// ./webAdmin/forms/institutionLicensePoolsAddSublicense.js